export default "__VITE_ASSET__CrnnQqll__"